/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const reply_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.48 4.543a1.5 1.5 0 0 0-2.6-1.018L1.42 9.439a1.5 1.5 0 0 0 0 2.034l5.458 5.914a1.5 1.5 0 0 0 2.6-1.018v-2.913h6a7.5 7.5 0 0 1 7.5 7.5v-6a7.5 7.5 0 0 0-7.5-7.5h-6l.003-2.913Z"
      clipRule="evenodd"
    />
  </svg>
)
export default reply_medium
